const buildParams = (prefix: string, obj: any, params: Array<string>) => {
  if (Array.isArray(obj)) {
    // Serialize array item.
    obj.forEach((element) => {
      buildParams(prefix + '[]', element, params);
    });
  } else if (obj !== null && typeof obj === 'object') {
    // Serialize object item.
    Object.keys(obj).forEach((key) => {
      buildParams(prefix + '[' + key + ']', obj[key], params);
    });
  } else if (obj !== undefined && obj !== null) {
    // Serialize scalar item.
    params.push(
      encodeURIComponent(prefix) + '=' + encodeURIComponent(obj.toString())
    );
  } else {
    // Serialize null item
    params.push(encodeURIComponent(prefix) + '=');
  }
};

/**
 * Serializes params object into a query string.
 *
 * Modified version of jQuery's param function. Needed because the formatting of jQuery's function doesn't work well
 * with Rails' param mapping when there is Arrays of Objects
 * Original method: https://github.com/jquery/jquery/blob/main/src/serialize.js#L55
 *
 * @param params object to serialize
 * @param skipParams array of params keys that should not be serialized
 * @returns {string} query param string
 */
const serializeParams = (params: any, skipParams: Array<string> = []) => {
  const serializedParams: Array<string> = [];

  Object.keys(params).forEach((param) => {
    if (skipParams.includes(param) || typeof params[param] === 'function') {
      return;
    }
    if (params[param] != null) {
      buildParams(param, params[param], serializedParams);
    }
  });

  // Return the resulting serialization
  return serializedParams.join('&');
};

export default serializeParams;
